"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.captureException = captureException;
exports.overrideGetCaptureExceptionOptionsFromPlainObject = overrideGetCaptureExceptionOptionsFromPlainObject;

var _ravenJs = _interopRequireDefault(require("raven-js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 提供使用Raven作为底层实现的方法
// captureException保证链式调用
function captureException() {
  _ravenJs.default.captureException.apply(_ravenJs.default, arguments);

  return this;
} // _getCaptureExceptionOptionsFromPlainObject 返回的message需要调整为对象字符串


function overrideGetCaptureExceptionOptionsFromPlainObject() {
  var origin = _ravenJs.default._getCaptureExceptionOptionsFromPlainObject; // eslint-disable-next-line

  _ravenJs.default._getCaptureExceptionOptionsFromPlainObject = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // eslint-disable-next-line
    var currentOptions = args[0],
        ex = args[1];
    var options = origin.apply(void 0, args);
    options.message = "Non-Error exception captured: ".concat(JSON.stringify(ex));
    return options;
  };
}